export const BRAND_ETUOVI = 'etuovi'
export const BRAND_NETTIAUTO = 'nettiauto'
export const BRAND_ILTALEHTI = 'iltalehti'
export const BRAND_KAUPPALEHTI = 'kauppalehti'

export const DAY_OLD_LABEL = '1 vrk'

/** Ampparit category slugs that map to a partner brand (also matches descendants via hierarchy). */
const CATEGORY_SLUG_TO_BRAND = {
  'koti-ja-asuminen': BRAND_ETUOVI,
  'autot-ja-liikenne': BRAND_NETTIAUTO,
  kotimaa: BRAND_ILTALEHTI,
  ulkomaat: BRAND_ILTALEHTI,
  urheilu: BRAND_ILTALEHTI,
  talous: BRAND_KAUPPALEHTI,
}

/** Tag slugs that map to a partner brand (e.g. /t/porssit and /omat whitelist). */
const TAG_SLUG_TO_BRAND = {
  porssit: BRAND_KAUPPALEHTI,
}

/**
 * @param {string[]} slugs Hierarchy from root to leaf
 * @returns {string|null}
 */
export function brandForCategorySlugs(slugs) {
  if (!slugs) return null
  for (const slug of slugs) {
    const brand = CATEGORY_SLUG_TO_BRAND[slug]
    if (brand) return brand
  }
  return null
}

/**
 * @param {string} slug
 * @returns {string|null}
 */
export function brandForTagSlug(slug) {
  if (!slug) return null
  return TAG_SLUG_TO_BRAND[slug] || null
}

/** Shared reference so selectors keep returning the same array between renders. */
const IL_SPORTS_CATEGORIES = ['urheilu']

/**
 * ILUutisboksi `categories` prop: sports pages get the sports feed, others stay general.
 * @param {string[]} slugs Hierarchy from root to leaf
 * @returns {string[]|undefined}
 */
export function ilUutisboksiCategoriesForSlugs(slugs) {
  if (!slugs || !slugs.includes('urheilu')) return undefined
  return IL_SPORTS_CATEGORIES
}

/**
 * First matching brand from the user's /omat selections.
 * Tags are more specific and are checked first, then categories, both in whitelist order.
 *
 * @param {{ tagSlugs: string[], categorySlugChains: string[][] }} selections
 * @returns {string|null}
 */
export function brandForPersonalSelections({ tagSlugs, categorySlugChains }) {
  if (tagSlugs) {
    for (const slug of tagSlugs) {
      const brand = brandForTagSlug(slug)
      if (brand) return brand
    }
  }
  if (categorySlugChains) {
    for (const slugs of categorySlugChains) {
      const brand = brandForCategorySlugs(slugs)
      if (brand) return brand
    }
  }
  return null
}

/**
 * Insert `component` after the first article that is older than 24 hours
 * (the first visible "1 vrk" time label and its following item).
 *
 * @param {Immutable.List} list
 * @param {object} component React element
 * @returns {Immutable.List}
 */
export function injectAfterFirstDayOldArticle(list, component) {
  if (!component || !list || list.size === 0) {
    return list
  }

  const labelIndex = list.findIndex((element) => {
    const { visible, labelText } = element?.props || {}
    return visible === true && labelText === DAY_OLD_LABEL
  })

  if (labelIndex === -1) {
    return list
  }

  const insertAt = Math.min(labelIndex + 2, list.size)
  return list.insert(insertAt, component)
}
